import { salesOrdersContracts } from "./sales-orders.contract";
import { salesOrderDraftsContracts } from "./sales-order-drafts.contract";
import { customerProductsContracts } from "./customer-products.contract";
import { discountsContracts } from "./discounts.contract";
import { salesOrdersRpcContracts } from "./sales-orders-rpc.contract";

export const accountsReceivableContracts = {
  stagedSalesOrders: salesOrdersContracts,
  salesOrderDrafts: salesOrderDraftsContracts,
  customerProducts: customerProductsContracts,
  discounts: discountsContracts,
  salesOrders: salesOrdersRpcContracts,
} as const;

export * from "./sales-orders-rpc.contract";
